import dayjs from "dayjs";
import { PageCard } from "components/page-card";
import { SimpleGridTable } from "components/simple-grid-table";
import { useFormatMoney } from "hooks/use-format-money";
import type { TenantPortalTenancy } from "types/tenancy";
import { dateFormats } from "utils/date";

type TenancyDetailsProps = {
  tenancy?: TenantPortalTenancy;
};

function getTenancyPaymentFrequencyLabel(tenancy?: TenantPortalTenancy) {
  if (!tenancy) {
    return "";
  }
  const { frequency_count = null, frequency_unit = null } = tenancy;

  return frequency_count && frequency_unit
    ? `${frequency_count} ${frequency_unit?.label}`
    : "–";
}

export function TenancyDetails({ tenancy }: TenancyDetailsProps) {
  const formatMoney = useFormatMoney();

  const dateFormat = (date: string | null | undefined) =>
    date ? dayjs(date).format(dateFormats.dayMonthYear) : "–";

  return (
    <PageCard heading={"Tenancy details"}>
      <SimpleGridTable
        items={[
          {
            label: "Lease start",
            value: dateFormat(tenancy?.agreement_start_date),
          },
          {
            label: "Rent position",
            value:
              "Fully paid until: " +
              dateFormat(tenancy?.rent_position?.paid_to_date),
          },
          {
            label: "Lease end",
            value: dateFormat(tenancy?.agreement_end_date),
          },
          {
            label: "Security deposit (total / due)",
            value: tenancy?.total_security_deposit_amount
              ? formatMoney(tenancy?.total_security_deposit_amount / 100) +
                " / " +
                formatMoney(
                  (tenancy?.total_security_deposit_amount -
                    tenancy?.paid_security_deposit_amount) /
                    100,
                )
              : "N/A",
          },
          {
            label: "Rent",
            value:
              formatMoney(tenancy?.rent_amount) +
              ` / ${getTenancyPaymentFrequencyLabel(tenancy)}`,
          },
          {
            label: "Tenants",
            value: tenancy?.tenants?.map((t) => t.name).join(", "),
          },
        ]}
      />
    </PageCard>
  );
}
